module.exports = "<div class=\"modal-container\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-dialog-header\">\n            <span class=\"dbm dbm-ic_close_48px\"></span>\n            <span>{{ data.title || 'Success - Action saved' }}</span>\n        </div>\n        <div class=\"modal-dialog-content\">{{data.text}}</div>\n        <div class=\"modal-dialog-footer\">\n            <button class=\"btn btn-default\" (click)=\"close()\">Ok</button>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dialogs/success-dialog/success-dialog.component.html
// module id = 1927
// module chunks = 0